import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = {
  page: 1,
  limit: 5,

  pageInfo: {
    page: 1,
    limit: 5,
    totalPage: 2
  },

  list: []
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
